import {ApolloClient, HttpLink, InMemoryCache} from '@apollo/client';
import fetch from 'cross-fetch';

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({uri: '/services/empire/api', fetch}),
});
